import { render, staticRenderFns } from "./Drill.vue?vue&type=template&id=1fc0c72b&scoped=true&"
import script from "./Drill.vue?vue&type=script&lang=ts&"
export * from "./Drill.vue?vue&type=script&lang=ts&"
import style0 from "./Drill.vue?vue&type=style&index=0&id=1fc0c72b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0c72b",
  null
  
)

component.options.__file = "Drill.vue"
export default component.exports